//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'

export default BaseCmsBlock.extend({
  name: "TextAndImageBlock",

  computed: {
    isVisibleRightContent: function () {
      return Boolean(this.imageId || this.videoLink)
    },

    titleText: function () {
      return this.values.title || ""
    },
    titleComponent: function () {
      return this.values?.title_size || "h2"
    },

    description: function () {
      return this.values?.description || ""
    },

    imageId: function () {
      return String(this.values?.image_id || '')
    },
    videoLink: function () {
      return this.values?.video_link || ''
    },

    buttonLink: function () {
      return this.values.button_link || "#"
    },
    buttonText: function () {
      return this.values.button_text || ""
    },
  }
});
